import { render, staticRenderFns } from "./TransportacionEP.vue?vue&type=template&id=e226989c&"
import script from "./TransportacionEP.vue?vue&type=script&lang=js&"
export * from "./TransportacionEP.vue?vue&type=script&lang=js&"
import style0 from "./TransportacionEP.vue?vue&type=style&index=0&id=e226989c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports